// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mega-spinner-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
}

.mega-spinner {
  border: 1vw solid rgba(255, 255, 255, 0.3);
  border-top: 1vw solid #fff;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}
.mega-spinner.grey {
  border: 1vw solid rgb(209, 209, 209);
  border-top: 1vw solid #9a9a9a;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/shared-components/components/smart-component-spinner/smart-component-spinner.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,0CAAA;EACA,0BAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;AACF;AACE;EACE,oCAAA;EACA,6BAAA;AACJ;;AAGA;EACE;IACE,uBAAA;EAAF;EAGA;IACE,yBAAA;EADF;AACF","sourcesContent":[".mega-spinner-overlay {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  height: 100%;\n}\n\n.mega-spinner {\n  border: 1vw solid rgba(255, 255, 255, 0.3);\n  border-top: 1vw solid #fff;\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n  animation: spin 1s linear infinite;\n\n  &.grey {\n    border: 1vw solid rgb(209, 209, 209);\n    border-top: 1vw solid #9a9a9a;\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
